<script lang="ts">
    import PricingCard from '../elements/PricingCard.svelte'
    import type { PriceCurrency } from '../../types'
    import { assets as assetPath } from '$app/paths'
    import { analytics } from '$lib/analytics';
    import CTA from '../../components/elements/CTA.svelte'

    let userCountryCode : string = 'EU'
    let startUpPrice = '500'
    let scaleUpPrice = '1250'
    let currency : PriceCurrency = '€'

    // const priceCurrency = () => {
    //     if(userCountryCode === 'GB') {
    //         startUpPrice = '450'
    //         scaleUpPrice = '1125'
    //         currency = '£'
    //     }else if(userCountryCode === 'ZA') {
    //         startUpPrice = '10k'
    //         scaleUpPrice = '25k'
    //         currency = 'R'
    //     }
    // }

    // const fetchRegion = async () => {
    //    try {
    //        let response = await fetch(import.meta.env.VITE_USER_LOCATION_ENDPOINT)
    //        let data = await response.json()

    //        userCountryCode = data.country_code
    //        priceCurrency()
    //    }catch (error) {
    //         console.log(error, 'fetch error')
    //    }
    // }

    // fetchRegion()

    const trackEvent = () => {
        analytics.track('Demand Activity', {
            source: 'demand landing page',
            label: 'organic demand role page',
            source_detail: 'pricing section',
            name: 'Demand Activity',
            category: 'marketing pages',
            action: 'clicked get access'
        })
    }
</script>
<div class="tiered-pricing">
    <div class="tiered-pricing__heading">
        <h2>Hiring plans for every budget</h2>
        <p>Our plans are designed for all budgets and team needs. Choose to pay-per-hire or make unlimited hires for a fixed monthly or annual cost and save up to 50% as you scale your team.</p>
    </div>
    <div class="tiered-pricing__items">
        <PricingCard
            tierIcon="{assetPath}/assets/pricing/scaleup.png"
            tierType="Pay-per-hire"
            cardDescription="For teams that need a <span>flexible pricing option.</span>"
            price="12.5%"
            priceDescription="success fee"
            showUnlimitedHires={false}
            pricingOption="pay-per-hire"
            tierBenefits={
                [
                    {description: 'Pay a 12.5% success fee per hire', active: true, highlight: true},
                    {description: 'Up to 3 seats for hiring managers', active: true},
                    {description: 'On demand customer support', active: true},
                    {description: 'New candidates weekly', active: true},
                    {description: 'Calendar integration', active: true},
                    {description: 'AI recommendations', active: true},
                    {description: '3 month refund period', active: true}
                ]
            }
            showCurrency={false}
        />
        <PricingCard
            tierIcon="{assetPath}/assets/pricing/enterprise.png"
            tierType="Unlimited Hires"
            cardDescription="For teams that want to save on hiring costs and <span>need to make more than 4 hires.</span>"
            price="Save up to 50%"
            priceDescription="with a custom fixed fee"
            showCurrency={false}
            tierBenefits={
                [
                    {description: 'Unlimited seats for hiring managers', active: true},
                    {description: 'Dedicated account manager', active: true},
                    {description: 'New candidates weekly', active: true},
                    {description: 'Calendar integration', active: true},
                    {description: 'AI recommendations', active: true},
                    {description: 'ATS integration', active: true},
                    {description: 'Hiring analytics', active: true},
                    {description: 'Salary benchmarking data', active: true},
                    {description: 'Quarterly executive business reviews', active: true},
                    {description: 'Multiple hiring teams', active: true},
                    {description: 'Premium employer profile', active: true},
                    {description: 'Unlimited promoted positions', active: false}


                ]
            }
            showRecommended={true}
        />
    </div>
    <CTA text="Get access to developers" url="https://www.offerzen.com/hire/get-started" className="pricing-cta" on:click={trackEvent}/>
</div>

<style lang="postcss">

    @import '../../styles/_mixins.css';

    .tiered-pricing {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position:relative;

        @mixin screen-sm {
                padding:0 24px;
                justify-content:flex-start;
        }

        & .tiered-pricing__heading {
            text-align: center;

            & h2 {
                @mixin heading-h2;
                margin:120px 0 16px;
                color:#fff;

                & span {
                    color:var(--color_offerzen_cerulean);
                }
            }

            & p {
                max-width: 700px;
                margin:0 0 60px;
                font-size:20px;
                color: #e4f0fc;
                line-height:150%;
            }

            @mixin screen-sm {
                text-align:left;
            }

        }

        & .tiered-pricing__items {
            display: flex;
            gap:40px;
            max-width: 1200px;
            width:100%;
            justify-content: center;
            margin-bottom:60px;


            @mixin screen-md {
                flex-wrap: wrap;
                justify-content:center;
                flex-direction:column-reverse;
                align-items:center;
                gap:60px
            }

            @mixin screen-sm {
                margin-bottom:40px;
                gap:60px 0;
            }
        }
    }

</style>